/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
import {CommonContractorCreateUpdateApp} from "../../../../Dashboard/Contractors/Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp";
import {EmployeeFlowSupplierUpdateApp} from "../../Funtionality/SupplierCreateUpdateFlows/EmployeeFlowSupplierUpdateApp";
import {permissionObj} from "../../../../../Helpers/permission";
import routes from "../../../../../Routes/routes";
import HeadTittle from "../../../../../components/HeadTittle";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {EditIcon} from "../../../../../components/buttons/IconButtons"
import ManagerFields from "../../../../Dashboard/Contractors/SubComponents/ContractorCreateUpdateFlows/ManagerFields";
import SupplierCompanyFields from "./SupplierCompanyFields";
import React from "react";
import StepperTabs from "../../../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../../../components/StepperTabs/StepTab";
import CustomPhotoPicker from "../../../../../components/PhotoPicker/CustomPhotoPicker";
import {ACTION_MODEL} from "../../../../../Helpers/ActionModel";
import {FILE_TYPE} from "../../../../../Helpers/fileType";
import {SUGGESTION_MODE_OPTION} from "../../../../../components/PhotoPicker/SubComponent/Models/Models";
import CopySecretModal from "../../../../Dashboard/Company/Employees/Modal/CopySecretModal";
import {STEPS_PROVIDER_UPDATE} from "../../../Model/Model";
import { validateMinLengthTrimmed } from "../../../../../Apis/functions";
import { PASSWORD_MIN_LENGTH } from "../../../../../constant/variable";

const EmployeeFlowSupplierUpdate = () => {

    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        dispatch,
        navigate,
        DEV,
        params,
        permission,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        isValidPassword,
        setIsValidPassword,
        setIsValidDocumentId,
        userInfoStatusList,
        emptyFields,
        setEmptyFields,
        handleDateChange,
        handleEmailChange,
        handlePasswordChange,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        disabled,
        activeStep,
        setActiveStep,
        steps,
        setSteps,
        handleStepChange,
        photoPicker,
        setPhotoPicker,
        modified,
        setModified
    }  = props;

    const {
        user,
        setUser,
        FormHandler,
        getAllServiceType,
        goBack
    } = EmployeeFlowSupplierUpdateApp({
        t,
        params,
        dispatch,
        navigate,
        permission,
        setEmptyFields,
        isValidDob,
        isValidPassword,
        photoPicker,
        setSecretModal,
        setSecretKey,
        setSteps,
        modified,
        setModified,
        setPhotoPicker,

    });


    if(!DEV &&
        (!permission?.includes(permissionObj.WEB_SUPPLIER_READ) ||
            !permission?.includes(permissionObj.WEB_SUPPLIER_UPDATE))) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle
                onBack={goBack}
                name={t("update")}
            >

                {(DEV || permission?.includes(permissionObj.WEB_SUPPLIER_UPDATE)) &&
                <ButtonAction
                    id={'btn_efs_update'}
                    name={'update'}
                    className={'btn-icon-edit'}
                    disabled={false}
                    Icon={EditIcon}
                    onClick={() => {
                        validateEmail(user.email);
                        validatePhone(user.phoneNumber);
                         const isValid = validateMinLengthTrimmed(user.password, {
                                minLength: PASSWORD_MIN_LENGTH,
                                allowEmpty: true,
                            });
                            setIsValidPassword(isValid);

                            if (!isValid) return;
                        FormHandler();
                    }}
                />
                }
            </HeadTittle>

            <StepperTabs id={user?.id} disabled={false} steps={steps} activeStep={activeStep} isStepOptional={step => step === 1}
                         setActiveStep={setActiveStep} handleStepChange={handleStepChange}
            >
                <StepTab index={STEPS_PROVIDER_UPDATE.COMPANY_DETAILS} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_PROVIDER_UPDATE.COMPANY_DETAILS &&
                        <SupplierCompanyFields
                            user={user}
                            setUser={setUser}
                            emptyFields={emptyFields}
                            getAllServiceType={getAllServiceType}
                        />
                    }
                </StepTab>
                <StepTab index={STEPS_PROVIDER_UPDATE.MANAGER_DETAILS} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_PROVIDER_UPDATE.MANAGER_DETAILS &&
                    <ManagerFields
                        title={"manager"}
                        user={user}
                        setUser={setUser}
                        emptyFields={emptyFields}
                        isValidDocumentId={isValidDocumentId}
                        setIsValidDocumentId={setIsValidDocumentId}
                        isValidEmail={isValidEmail}
                        isValidPhoneNumber={isValidPhoneNumber}
                        isValidDob={isValidDob}
                        setIsValidDob={setIsValidDob}
                        handleEmailChange={handleEmailChange}
                        handlePasswordChange={handlePasswordChange}
                        handlePhoneNumberChange={handlePhoneNumberChange}
                        handleDateChange={handleDateChange}
                        statusList={userInfoStatusList}
                    />
                    }
                </StepTab>
                <StepTab index={STEPS_PROVIDER_UPDATE.ADD_PHOTO} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_PROVIDER_UPDATE.ADD_PHOTO &&
                    <CustomPhotoPicker
                        id='fp_ce_update_photo_profile'
                        photoPicker={photoPicker}
                        setPhotoPicker={setPhotoPicker}
                        actionModel={ACTION_MODEL.UPDATE}
                        accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                        showBtnCamera={true}
                        validateFace={true}
                        classWith={'w-400px'}
                        showPreview={true}
                        disabled={disabled}
                        titleModalEdit='update_photography'
                        typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE} // It is required if showBtnCamera is true
                    />
                    }
                </StepTab>
            </StepperTabs>

            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                onHide={() => {}}
                closeText={'close'}
            />
        </>
    );
};
export default EmployeeFlowSupplierUpdate
